module.exports = __webpack_public_path__ + "static/media/dongyanshanadj.cbba015f.webp";